// Token 存储键名
const TOKEN_ACCESS_KEY = 'token_access'
const TOKEN_REFRESH_KEY = 'token_refresh'
const USER_INFO_KEY = 'user_info'

import type { AdminModel } from '@ay-shared-core/types/admin'

// 获取 Access Token
export const getAccessToken = (): string | null => {
  return localStorage.getItem(TOKEN_ACCESS_KEY)
}

// 获取 Refresh Token
export const getRefreshToken = (): string | null => {
  return localStorage.getItem(TOKEN_REFRESH_KEY)
}

// 设置 Token
export const setTokens = (accessToken: string, refreshToken: string): void => {
  localStorage.setItem(TOKEN_ACCESS_KEY, accessToken)
  localStorage.setItem(TOKEN_REFRESH_KEY, refreshToken)
}

// 清除 Token
export const clearTokens = (): void => {
  localStorage.removeItem(TOKEN_ACCESS_KEY)
  localStorage.removeItem(TOKEN_REFRESH_KEY)
}

// 检查是否有 Token
export const hasToken = (): boolean => {
  return !!getAccessToken()
}

// 获取用户信息
export const getUserInfo = (): AdminModel | null => {
  const info = localStorage.getItem(USER_INFO_KEY)
  if (!info) return null
  try {
    return JSON.parse(info) as AdminModel
  } catch {
    return null
  }
}

// 设置用户信息
export const setUserInfo = (info: AdminModel): void => {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(info))
}

// 清除用户信息
export const clearUserInfo = (): void => {
  localStorage.removeItem(USER_INFO_KEY)
}
